import { render, staticRenderFns } from "./seckillSetting.vue?vue&type=template&id=6858c2c9&scoped=true&"
import script from "./seckillSetting.vue?vue&type=script&lang=js&"
export * from "./seckillSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858c2c9",
  null
  
)

export default component.exports